import {
  useMountedPortal,
  type UsePortalOptions,
} from '#app/hooks/useMountedPortal.js';
import { type ReactNode } from 'react';

type MountedPortalProps<K extends keyof HTMLElementTagNameMap> = Omit<
  UsePortalOptions<K>,
  'key'
> & {
  readonly children: ReactNode;
  readonly portalKey?: string;
};

/**
 * A renderable version of `useMountedPortal`.
 * Allows you to describe the JSX children content in the render portion of a consumer component
 * instead of via the hook in the consumer component.
 */
export const MountedPortal = <K extends keyof HTMLElementTagNameMap>({
  children,
  portalKey,
  ...portalOptions
}: MountedPortalProps<K>): JSX.Element => {
  const portal = useMountedPortal(children, {
    ...portalOptions,
    key: portalKey,
  });

  return <>{portal}</>;
};
